import { AxiosResponse } from 'axios';
import { handleError, URL_GESTIFY_AUTH, URL_LOGIN } from '../../utils';
import { AuthParams } from '../../models';
import { apiClient } from '../../helpers';
import {
  addGestifyTokenCookies,
  removeGestifyTokenCookies,
} from '../../helpers/authCookies';

export enum LoginResultCode {
  NO_AZIENDE = 'no_aziende',
  USER_DISABLED = 'user_disabled',
}

export const gestifyLogin = async (auth: AuthParams) => {
  try {
    const response = await apiClient.post<AxiosResponse>({
      url: `${URL_GESTIFY_AUTH}${URL_LOGIN}`,
      params: auth,
    });
    if (response.status === 200 || response.status === 201) {
      if (
        response.data?.status?.result_code !== LoginResultCode.NO_AZIENDE &&
        response.data?.status?.result_code !== LoginResultCode.USER_DISABLED
      ) {
        addGestifyTokenCookies({
          gestifyToken: response.data.access_token,
          gestifyRefreshToken: response.data.refresh,
        });
      }
      return response.data;
    }
    removeGestifyTokenCookies();
    return handleError(response.status, response.data?.status);
  } catch (e) {
    removeGestifyTokenCookies();
    console.log(e);
    console.log(500, e);
  }
};
